
import React from 'react'


import './index.scss'

export default React.memo(function ({
    info,
    ruleCls
}) {
    function toRule() {
        window.locationTo({
            url: info.ruleUrl
        })
    }
    return (
        <div className="com-head">
            <div className='com-bg'>
                <div className='com-head-null'></div>
                <div className='com-head-line'>
                    <img
                        alt=''
                        className='icon'
                        src='//img10.360buyimg.com/imagetools/jfs/t1/165772/7/14113/27787/605840cfEd8c07df5/e82b515e7b80e9de.png'
                    />
                    {info.ruleUrl?<div className='rule' onClick={toRule} clstag={ruleCls}>规则</div>: null}
                </div>

                <div className='com-head-title'>
                    <div className='left'>
                        <div className='main-title'>{info.mainTitle}</div>
                        <div className='sub-title'>{info.subTitle}</div>
                    </div>
                    <div className='right'>
                        { info.icon? <img src={info.icon} alt='' />: null}
                    </div>
                </div>
            </div>

        </div>
    )
})


